var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrepaGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.2 31.2",
    style: {
      enableBackground: "new 0 0 31.2 31.2"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #52a73e;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,1.9c2.3-.5,4.7-.3,6.9.7,2,.9,3.6,2.5,4.7,4.3,1.1,1.9,1.5,4.1,1.3,6.2-.2,1.8-1.1,3.5-2.1,5.1-.9,1.4-2,2.6-3,3.8-1.8,2.1-3.6,4.2-5.4,6.3-2.1-2.2-4.1-4.4-6.1-6.7-1.3-1.5-2.6-3.1-3.4-5-.9-1.9-1.2-4-.9-6,.3-2.2,1.3-4.2,2.8-5.8,1.4-1.4,3.2-2.5,5.2-2.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.37,2.69c-.25,2.08,1.33,4.03,5.04,9.55,1.35,2.01-3.39,14.07-2.09,15.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrepaGreen);
export default __webpack_public_path__ + "static/media/crepa_green.cc3d82d973f0d0f3fafbf29781b835ea.svg";
export { ForwardRef as ReactComponent };